export const PLAN_CARD_TEST_ID = {
    CARD: 'plan-card',
    CAP: 'plan-card-cap',
    SUBTITLE: 'plan-card-subtitle',
    BADGE: 'plan-card-badge',
    TITLE: 'plan-card-title',
    OLD_TITLE: 'plan-card-old-title',
    DETAILS_LIST: 'plan-card-details-list',
    DETAILS_ITEM: 'plan-card-details-item',
    DETAILS_MODAL: 'plan-card-details-modal',
    OLD_PRICE: 'plan-card-old-price',
    PRICE: 'plan-card-price',
    CONTRACT_SUMMARY: 'plan-card-contract-summary',
    CTA: 'plan-card-call-to-action',
    FOOTER: 'plan-card-footer',
    DESCRIPTION_LIST: 'plan-card-description-list',
    DESCRIPTION_MODAL: 'plan-card-description-modal',
    DESCRIPTION_MODAL_TRIGGER: 'description-modal-trigger-button',
};
